<template>
    <v-menu offset-y content-class="ag-grid-vmenu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" width="15">
          <v-icon color="secondary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in params.items"
          :key="index"
          @click="handleAction(item.action)"
        >
          <v-list-item-icon>
            <v-icon :color="item.iconColor || 'primary'">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
export default {
  methods: {
    handleAction(action) {
      if (typeof action === 'function') {
        action(this.params?.data, this.params?.context?.componentParent)
      } else {
        console.warn('No valid action provided for menu item:', action)
      }
    }
  } 
}
</script>

<style scoped>
.ag-grid-vmenu .v-list {
  padding: 3px 0;
}
.ag-grid-vmenu .v-list .v-list-item__icon[data-v-757d3da0] {
  margin: 0;
  margin-top: 7px;
  margin-left: 7px;
}
.ag-grid-vmenu .v-list .v-list-item {
  width: 170px;
  padding: 0 10px 0 0;
}
</style>
